// @flow
import styled from 'styled-components';
import { alignItems, space } from 'styled-system';
import { fontWeights, colors } from '../theme';

const Label = styled.label`
  font-size: 13px;
  font-weight: ${fontWeights.semiBold};
  color: ${colors.battleshipGrey};
  margin-bottom: 4px;
  align-items: center;
  display: flex;
  ${alignItems} ${space};
`;

export default Label;
